import styled from 'styled-components';

export const MenuContainer = styled.div`
  border-radius: 5px;
  padding: 20px;
  width: 269px;
  background-color: white;
  color: var(--darkest-color);
  display: flex;
  flex-direction: column;
  z-index: 2;
  position: relative;
  > div {
    display: flex;
    flex-direction: row;
    width: 100%;
    div:first-child {
      width: 20%;
    }
    div:last-child {
      width: 100%;
    }
    margin-top: 10px;
    padding: 10px;
    cursor: pointer;
    &:hover {
      background: var(--titan-blue-1);
    }
  }
  .top {
    text-align: center;
    display: block;
    padding-bottom: 20px;
    cursor: default;
    > div {
      width: 100% !important;
      margin-bottom: 20px;
    }
    margin-top: 0;
    border-bottom: solid 1px var(--grey-3);
    img {
      border-radius: 50%;
    }
    &:hover {
      background: none;
    }
  }
`;
